import type { RecentRun } from "./progression";

export interface ShareCardData {
  player: string;
  run: RecentRun;
  campaignComplete: boolean;
}

export function shareText(data: ShareCardData): string {
  const achievement =
    data.run.mode === "campaign"
      ? `${data.run.levelName} · ${data.run.stars}/3 stars`
      : `${data.run.clogs} toilets clogged`;
  return `${data.player} scored ${data.run.score.toLocaleString()} in Buttroids — ${achievement}!`;
}

export async function renderShareCard(data: ShareCardData): Promise<Blob> {
  const canvas = document.createElement("canvas");
  canvas.width = 1200;
  canvas.height = 630;
  const context = canvas.getContext("2d");
  if (!context) throw new Error("Score-card drawing is unavailable.");

  const gradient = context.createLinearGradient(0, 0, 1200, 630);
  gradient.addColorStop(0, "#160d2a");
  gradient.addColorStop(0.55, "#4d275f");
  gradient.addColorStop(1, "#17646b");
  context.fillStyle = gradient;
  context.fillRect(0, 0, 1200, 630);
  context.fillStyle = "rgba(113, 228, 208, .14)";
  context.beginPath();
  context.arc(1030, 110, 250, 0, Math.PI * 2);
  context.fill();
  context.fillStyle = "#ffcf5c";
  context.font = "700 30px system-ui, sans-serif";
  context.fillText("COSMIC CLOG REPORT", 72, 92);
  context.fillStyle = "#fff3d6";
  context.font = "800 68px system-ui, sans-serif";
  context.fillText(data.player, 72, 190);
  context.fillStyle = "#71e4d0";
  context.font = "800 112px system-ui, sans-serif";
  context.fillText(data.run.score.toLocaleString(), 72, 335);
  context.fillStyle = "#fff3d6";
  context.font = "700 36px system-ui, sans-serif";
  context.fillText(data.run.levelName, 76, 405);
  context.fillStyle = "#ffc4dc";
  context.font = "600 29px system-ui, sans-serif";
  const detail =
    data.run.mode === "campaign"
      ? `${"★".repeat(data.run.stars)}${"☆".repeat(3 - data.run.stars)} · ${data.run.clogs} clogged · ${data.run.weapon}`
      : `${data.run.clogs} clogged · ${data.run.weapon}`;
  context.fillText(detail, 76, 458);
  context.fillStyle = "rgba(255,255,255,.86)";
  context.font = "600 28px system-ui, sans-serif";
  context.fillText(
    data.campaignComplete
      ? "Certified Cosmic Clog Champion"
      : "Fill. Wobble. Clog.",
    76,
    548,
  );
  context.fillStyle = "#ff8fbd";
  context.font = "900 54px system-ui, sans-serif";
  context.fillText("BUTTROIDS", 796, 548);

  return await new Promise<Blob>((resolve, reject) =>
    canvas.toBlob(
      (blob) =>
        blob
          ? resolve(blob)
          : reject(new Error("Score card could not be created.")),
      "image/png",
    ),
  );
}
